export default __webpack_public_path__ + "static/media/hiw_img.96780a51.svg";